import { formatYYYYMPeriod } from '@/utils/stringUtils';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, HStack, Menu, MenuButton, MenuItem, MenuList, Text, VStack } from '@chakra-ui/react';
import React, { useMemo } from 'react';

interface Props {
  // Current selection as `yyyy-m` (1-indexed, no zero-pad — matches the peer-support hook's format).
  value: string;
  onChange: (month: string) => void;
  // How many past months (including the current one) to offer in the dropdown.
  monthsBack?: number;
}

const DataPeriodSelector = ({ value, onChange, monthsBack = 12 }: Props) => {
  const options = useMemo(() => {
    const now = new Date();
    return Array.from({ length: monthsBack }, (_, i) => {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      return `${d.getFullYear()}-${d.getMonth() + 1}`;
    });
  }, [monthsBack]);

  return (
    <Menu placement={'bottom-end'} matchWidth>
      <MenuButton as={Box} cursor={'pointer'} _hover={{ opacity: 0.9 }}>
        <HStack
          alignItems={'center'}
          gap={'14px'}
          paddingX={'18px'}
          paddingY={'8px'}
          backgroundColor={'white'}
          borderRadius={'10px'}
          border={'1px solid'}
          borderColor={'text.mediumBlue'}
          style={{ boxShadow: '0px 2px 8px 0px #00417926' }}
          minWidth={'180px'}
          justifyContent={'space-between'}
        >
          <VStack alignItems={'start'} gap={'2px'}>
            <Text variant={'urbanistMaximumBold10'} color={'text.mediumGray'}>
              DATA PERIOD
            </Text>
            <Text variant={'urbanistBold'} color={'text.darkBlue'} fontSize={'14px'}>
              {formatYYYYMPeriod(value)}
            </Text>
          </VStack>
          <ChevronDownIcon boxSize={5} color={'text.mediumBlue'} />
        </HStack>
      </MenuButton>
      <MenuList minWidth={'180px'} maxHeight={'320px'} overflowY={'auto'}>
        {options.map((option) => (
          <MenuItem key={option} onClick={() => onChange(option)} fontSize={'14px'}>
            {formatYYYYMPeriod(option)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default DataPeriodSelector;
